/* eslint-disable i18next/no-literal-string */
import { memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { isSmallScreen } from 'common/utilities';
import { useAppSelector } from 'store';

export const containerTokens = {
  childrenGap: 55,
  padding: '30px 30px',
  maxWidth: 1040,
};

export const getStyles = memoizeFunction((smallScreen) => {
  return mergeStyleSets({
    header: {
      lineHeight: '32px',
      marginBottom: '16px',
      display: 'block',
    },
    errorType: {
      marginBottom: '60px',
    },
    detailsText: {
      marginBottom: '48px',
      marginTop: '20px!important',
    },
    content: {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      textAlign: smallScreen ? 'center' : undefined,
      alignItems: smallScreen ? 'center' : undefined,
      alignSelf: 'center',
    },
    buttonsContainer: {
      overflow: 'hidden',
    },
    button: {
      height: '32px',
      width: '136px',
    },
    verticalStack: {
      alignItems: smallScreen ? 'center' : undefined,
    },
  });
});

export const useStyles = () => {
  const { screenSize } = useAppSelector((state) => state.layout);
  const smallScreen = isSmallScreen(screenSize);
  return getStyles(smallScreen);
};
